import React, { useState } from 'react';
import Navbar from '../components/storefront/Navbar';
import Footer from '../components/storefront/Footer';
import { useNavigate } from 'react-router-dom';
import { FiSearch, FiPackage } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import supabase from '../supabase/supabase';
import LoadingSpinner from '../common/LoadingSpinner';

const OrderTrackingSearch = () => {
  const [orderId, setOrderId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    const cleanId = orderId.trim().replace(/^#/, '').toLowerCase();
    
    if (!cleanId) return;

    if (cleanId.length === 36) {
      navigate(`/track/${cleanId}`);
      return;
    }

    if (cleanId.length < 4) {
      setError('Please enter a valid order number.');
      return;
    }

    setLoading(true);
    try {
      const { data, error: fetchError } = await supabase.from('orders').select('id');
      if (fetchError) throw fetchError;
      
      if (data) {
        const match = data.find(o => o.id.toLowerCase().startsWith(cleanId));
        if (match) {
          navigate(`/track/${match.id}`);
        } else {
          setError('Order not found. Please check your order number.');
        }
      }
    } catch (err) {
      setError('Error searching for order. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-brand-sand min-h-screen font-sans flex flex-col pt-24">
      <Navbar />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="bg-white/90 p-10 md:p-12 rounded-3xl border border-white shadow-xl text-center max-w-lg w-full">
          <div className="w-16 h-16 bg-brand-gold/10 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiPackage} className="w-8 h-8 text-brand-gold" />
          </div>
          
          <h2 className="text-3xl font-serif text-brand-darkSage mb-3">Track Your Order</h2>
          <p className="text-brand-lightText text-sm mb-8">
            Enter your order number below to check the current status of your delivery.
          </p>

          <form onSubmit={handleSearch} className="space-y-4">
            <div className="relative">
              <SafeIcon icon={FiSearch} className="absolute left-4 top-1/2 -translate-y-1/2 text-brand-lightText" />
              <input
                type="text"
                placeholder="e.g. #E68967B7"
                value={orderId}
                onChange={(e) => setOrderId(e.target.value)}
                disabled={loading}
                className="w-full pl-12 pr-4 py-4 rounded-xl border border-gray-200 focus:border-brand-gold focus:ring-1 focus:ring-brand-gold outline-none text-brand-darkSage disabled:opacity-50"
                required
              />
            </div>
            
            {error && (
              <p className="text-red-500 text-sm bg-red-50 py-2 px-4 rounded-lg border border-red-100">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-darkSage text-white py-4 rounded-xl font-bold uppercase tracking-widest text-xs hover:bg-brand-gold transition-colors shadow-md disabled:opacity-70 flex justify-center items-center gap-2"
            >
              {loading ? (
                <>
                  <LoadingSpinner size="sm" />
                  Searching...
                </>
              ) : 'Track Order'}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OrderTrackingSearch;